// removed by extract-text-webpack-plugin
module.exports = {"imageBlock":"_1Z2Ac","image":"_1-GWG","playIcon":"_2gHix","timeSpan":"_OpRbA","video":"_eoiNh"};


//////////////////
// WEBPACK FOOTER
// ./app/components/MediaImage/MediaImage.scss
// module id = 1111
// module chunks = 1